import {
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Typography, Grid, TextField } from "@mui/material";
import CommonDialog from "../../common/commonDialog";

const useStyles = makeStyles((theme) => ({
  checkLabelFont: {
    marginLeft: "12px!important",
    color: "#292929!important",
    fontSize: "1rem!important",
  },
  checkFont: {
    display: "flex",
    justifyContent: "start",
    marginLeft: "0px!important",
  },
}));

const OffsetGlTypeModal = (props) => {
  const classes = useStyles();

  const { open, onCancel, onSave, offsetGLData, setOffsetGLData } = props;

  // Safety check: ensure offsetGLData is always defined
  const safeOffsetGlTypeData = offsetGLData || {
    offsetGlTypeId: null,
    name: "",
    code: "",
  };

  const onInputChange = (event) => {
    const { name, value } = event.target;
    const updatedData = { ...safeOffsetGlTypeData, [name]: value };
    setOffsetGLData(updatedData);
  };

  return (
    <CommonDialog
      onCancel={onCancel}
      onSave={onSave}
      open={open}
      primaryButtonLabel={"Save"}
      secondaryButtonLabel={"Cancel"}
      title={"Offset GL"}
    >
      <Grid container spacing={2}>
    
        <Grid item sm={12} xs={12}>
          <TextField
            fullWidth
            id="outlined-search"
            label="Code"
            name="code"
            type="text"
            size="small"
            value={safeOffsetGlTypeData.code || ""}
            onChange={onInputChange}
          />
        </Grid>

        <Grid item sm={12} xs={12}>
          <TextField
            fullWidth
            id="outlined-search"
            label="Name"
            name="name"
            multiline
            rows={2}
            value={safeOffsetGlTypeData.name || ""}
            onChange={onInputChange}
          />
        </Grid>
 
      </Grid>
    </CommonDialog>
  );
};
export default OffsetGlTypeModal;
